import styled from 'styled-components';

export const Floating = styled.div`
  position: relative;

  p {
    position: absolute;
    color: ${({ theme: { colors }, dark }) =>
      dark ? colors.black : colors.white};
    font-size: 12px;
    margin: 0;
    font-weight: ${({ dark }) => (dark ? 600 : 400)};
    letter-spacing: 2.9px;
    line-height: 15px;
    text-transform: uppercase;
    writing-mode: ${({ horizontal }) => (horizontal ? 'unset' : 'vertical-rl')};
    max-width: 12px;
    white-space: nowrap;
    transform: ${({ invert }) =>
      invert ? 'rotate(180deg) translateY(100%)' : 'rotate(180deg)'};
    padding-bottom: 60px;

    ${({ horizontal }) =>
      horizontal &&
      `position: static; transform: unset; display: inline-block; padding-bottom: 0;`}

    span {
      display: inline-block;
      position: ${({ horizontal }) => (horizontal ? 'static' : 'absolute')};
      height: ${({ horizontal }) => (horizontal ? '1px' : '22px')};
      width: ${({ horizontal }) => (horizontal ? '22px' : '1px')};
      background-color: ${({ theme: { colors }, dark }) =>
        dark ? colors.black : colors.white};
      bottom: 0px;
      left: 5px;

      ${({ horizontal }) =>
        horizontal &&
        `
        margin-left: 43px;
        transform: translateY(-3px);
      `}
    }
  }

  @media only screen and (max-width: 767px) {
    display: none;
  }
`;
